import { h } from 'preact'
import ButtonControl from '../../button-control'
import Panel from '../../panel'
import AppliedFilter from '../../articles/AppliedFilter'
import AuthorSelector from '../../articles/AuthorSelector'
import Icon from '../../assets'
import SearchBox from '../../search-box/SearchBox'
import PillContainer from '../../pills/PillContainer'
import Pill from '../../pills/Pill'
import PublicLabelSelector from '../../articles/PublicLabelSelector'
import { appliedFilters } from './Overview'
import { Author } from './Types'

interface Props {
    labels: Array<string>,
    authors: Array<Author>,
    filters: any,
    onFilterChange: (type: string, filters:Array<appliedFilters>) => void, 
    onClearFilterCriteria: () => void
  }

const OverviewFilters = ({ labels, authors, filters, onFilterChange, onClearFilterCriteria }: Props) => {
  let appliedFilters: Array<any> = []
  Object.keys(filters).forEach(key => filters[key].length && appliedFilters.push(filters[key][0]))
  const areFiltersApplied = appliedFilters.length > 0
  return (
    <div>
      <Panel>
        <div class='articles-overview__filters-container'>
          <PublicLabelSelector
            labels={labels}
            selected={filters.label[0] && { type: 'label', name: filters.label[0].name }}
            onFilterChange={(e: ChangeEvent) => onFilterChange('label', [{ id: e.target.getAttribute('value') as string, name: e.target.getAttribute('value') as string, type: 'label' }])}
          />
          <AuthorSelector
            authors={authors}
            selected={filters.author[0] && { type: 'author', name: filters.author[0].name }}
            onFilterChange={(e: ChangeEvent) => onFilterChange('author', [{ id: e.target.getAttribute('value') as string, name: e.target.textContent as string, type: 'author' }])}
          />
          <SearchBox
            value={filters.search[0] && filters.search[0].name}
            placeholder='Search in title and content'
            onSubmit={(value: string) => onFilterChange('search', [{ id: value, name: value, type: 'search' }])} />
        </div>
      </Panel>
      {
        areFiltersApplied &&
          <PillContainer>
            {
              appliedFilters.map(({ type, name }) =>
                <Pill>
                  <AppliedFilter type={type} name={name} />
                  <Icon customClass={`qa-dismiss-${type}-filter-pill`} icon='close' width={16} height={16} onClick={() => onFilterChange(type, [])} />
                </Pill>
              )
            }
            <ButtonControl
              class='articles-overview__filters-clear'
              title='Clear selection'
              variant='warning'
              onClick={onClearFilterCriteria}
            />
          </PillContainer>
      }
    </div>
  )
}

export default OverviewFilters
